import pako from 'pako';
import { MethodNotImplementedError } from '../../core/errors.js';
import PDFName from '../../core/objects/PDFName.js';
import PDFStream from '../../core/objects/PDFStream.js';
import { Cache } from '../../utils/index.js';
class PDFFlateStream extends PDFStream {
    contentsCache;
    encode;
    constructor(dict, encode) {
        super(dict);
        this.encode = encode;
        if (encode)
            dict.set(PDFName.of('Filter'), PDFName.of('FlateDecode'));
        this.contentsCache = Cache.populatedBy(this.computeContents);
    }
    computeContents = () => {
        const unencodedContents = this.getUnencodedContents();
        return this.encode ? pako.deflate(unencodedContents) : unencodedContents;
    };
    getContents() {
        return this.contentsCache.access();
    }
    getContentsSize() {
        return this.contentsCache.access().length;
    }
    getUnencodedContents() {
        throw new MethodNotImplementedError(this.constructor.name, 'getUnencodedContents');
    }
}
export default PDFFlateStream;
//# sourceMappingURL=PDFFlateStream.js.map